import { MutationTree } from 'vuex';
import { NotificationsState } from '../stores/notifications.store';
import { INotification } from '@/types/Notification';

export const mutationSetNotifications = 'setNotifications';
export const mutationSetError = 'setError';

export const mutations: MutationTree<NotificationsState> = {
  [mutationSetNotifications](state, notifications: INotification[]) {
    state.notifications = notifications;
  },
  [mutationSetError](state, error) {
    state.error = error;
  },
};
